<template>
  <ChartDialog
    v-model="dialog"
    :title="title"
  >
    <v-tabs
      v-model="tab"
      centered
      grow
      :show-arrows="false"
    >
      <v-tabs-slider color="yellow"></v-tabs-slider>

      <v-tab>
        weekly
      </v-tab>
      <v-tab>
        Monthly
      </v-tab>
      <v-tab>
        Training Item
      </v-tab>
    </v-tabs>
    <v-tabs-items
      ref="tabsItemsRef"
      v-model="tab"
      :style="{ height: nodeHeight }"
      class="chart-tabs"
    >
      <v-tab-item>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Workout Type</span>
          <LineChart
            ref="weeklyWordoutTypeRef"
            :data="weeklyWorkoutType"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :y-axis="workoutTypeYAxis"
            :color="getRandomColor(0)"
            legend="Workout Type"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Workout Intensity</span>
          <LineChart
            ref="weeklyWorkoutIntensityRef"
            :data="weeklyWorkoutIntensity"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :color="getRandomColor(1)"
            legend="Workout Intensity"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Sleep</span>
          <LineChart
            ref="weeklySleepRef"
            :data="weeklySleep"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :color="getRandomColor(2)"
            legend="Hours"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Appetite</span>
          <LineChart
            ref="weeklyAppetiteRef"
            :data="weeklyAppetite"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :y-axis="courseCommentYAxis"
            :color="getRandomColor(3)"
            legend="Appetite"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Mood</span>
          <LineChart
            ref="weeklyMoodRef"
            :data="weeklyMood"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :y-axis="courseCommentYAxis"
            :color="getRandomColor(4)"
            legend="Mood"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Energy</span>
          <LineChart
            ref="weeklyEnergyRef"
            :data="weeklyEnergy"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :y-axis="courseCommentYAxis"
            :color="getRandomColor(5)"
            legend="Energy"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Body Weight</span>
          <LineChart
            ref="weeklyBodyWeightRef"
            :data="weeklyBodyWeight"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :color="getRandomColor(6)"
            legend="KG"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Calories Expended</span>
          <LineChart
            ref="weeklyCaloriesExpendedRef"
            :data="weeklyCaloriesExpended"
            :categories="weeklyCategories"
            :x-axis="weeklyXAxis"
            :color="getRandomColor(7)"
            legend="Cals"
          ></LineChart>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Workout Type</span>
          <LineChart
            ref="monthlyWordoutTypeRef"
            :data="monthlyWorkoutType"
            :categories="monthlyCategories"
            :y-axis="workoutTypeYAxis"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(0)"
            legend="Workout Type"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Workout Intensity</span>
          <LineChart
            ref="monthlyWorkoutIntensityRef"
            :data="monthlyWorkoutIntensity"
            :categories="monthlyCategories"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(1)"
            legend="Workout Intensity"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Sleep</span>
          <LineChart
            ref="monthlySleepRef"
            :data="monthlySleep"
            :categories="monthlyCategories"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(2)"
            legend="Hours"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Appetite</span>
          <LineChart
            ref="monthlyAppetiteRef"
            :data="monthlyAppetite"
            :categories="monthlyCategories"
            :y-axis="courseCommentYAxis"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(3)"
            legend="Appetite"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Mood</span>
          <LineChart
            ref="monthlyMoodRef"
            :data="monthlyMood"
            :categories="monthlyCategories"
            :y-axis="courseCommentYAxis"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(4)"
            legend="Mood"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Energy</span>
          <LineChart
            ref="monthlyEnergyRef"
            :data="monthlyEnergy"
            :categories="monthlyCategories"
            :y-axis="courseCommentYAxis"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(5)"
            legend="Energy"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Body Weight</span>
          <LineChart
            ref="monthlyBodyWeightRef"
            :data="monthlyBodyWeight"
            :categories="monthlyCategories"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(6)"
            legend="KG"
          ></LineChart>
        </v-card>
        <v-card class="mb-3 pl-2 pr-2 pt-2">
          <span class="font-weight-black">Calories Expended</span>
          <LineChart
            ref="monthlyCaloriesExpendedRef"
            :data="monthlyCaloriesExpended"
            :categories="monthlyCategories"
            :x-axis="monthlyXAxis"
            :color="getRandomColor(7)"
            legend="Cals"
          ></LineChart>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          v-for="(trainingItem,index) in record.trainingItems"
          ref="trainingItemsRef"
          :key="trainingItem.id"
          class="mb-3 pl-2 pr-2 pt-2"
        >
          <span class="font-weight-black">{{ getCourseItemDesc(trainingItem.courseItemID) }}</span>
          <!-- :series="getChartDataFromTrainingSet(trainingItem)" -->
          <TwoLineChart
            :ref="el=>assignRef(el,index)"
            title1="lbs/Kgs"
            :title2="getUnit(trainingItem.courseItemID)"
            :color1="getRandomColor(0)"
            :color2="getRandomColor(1)"
            :series="getSeries(trainingItem)"
          ></TwoLineChart>
          <span class="font-weight-black">{{ trainingItem.remark }}</span>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ChartDialog>
</template>
<script setup>
import { ref, onMounted, computed, watch, toRefs, onBeforeUnmount } from 'vue'
import { getVuetify } from '@core/utils'
import { formatTime, formatDate, loading, getStartOfMonth } from '@/utils/helper'
import ChartDialog from './ChartDialog.vue'
import LineChart from '@/components/Chart/LineChart.vue'
import TwoLineChart from '@/components/Chart/TwoLineChart.vue'
import { listForChart,
  listCourseItem,
  listTrainingSetUnit,
} from '@/api/diaryRecord'
import moment from '@/utils/moment'
import { fetchWorkoutType, fetchCourseComment } from '@/api/courseComment'

const tabsItemsRef = ref(null)

const $vuetify = getVuetify()

const trainingItemsRef = ref(null)

const courseItems = ref([])
listCourseItem({}).then(res => {
  console.log('listCourseItem', res)
  courseItems.value = [...res.data.items]
})
const trainingSetUnits = ref([])
listTrainingSetUnit({}).then(res => {
  console.log('listTrainingSetUnit', res)
  trainingSetUnits.value = [...res.data.items]
})

const weeklyWordoutTypeRef = ref(null)
const weeklyWorkoutType = ref([])

const weeklyWorkoutIntensityRef = ref(null)
const weeklyWorkoutIntensity = ref([])

const weeklySleepRef = ref(null)
const weeklySleep = ref([])

const weeklyAppetiteRef = ref(null)
const weeklyAppetite = ref([])

const weeklyMoodRef = ref(null)
const weeklyMood = ref([])

const weeklyEnergyRef = ref(null)
const weeklyEnergy = ref([])

const weeklyBodyWeightRef = ref(null)
const weeklyBodyWeight = ref([])

const weeklyCaloriesExpendedRef = ref(null)
const weeklyCaloriesExpended = ref([])

const weeklyCategories = ref([])
const monthlyCategories = ref([])

const monthlyWordoutTypeRef = ref(null)
const monthlyWorkoutType = ref([])

const monthlyWorkoutIntensityRef = ref(null)
const monthlyWorkoutIntensity = ref([])

const monthlySleepRef = ref(null)
const monthlySleep = ref([])

const monthlyAppetiteRef = ref(null)
const monthlyAppetite = ref([])

const monthlyMoodRef = ref(null)
const monthlyMood = ref([])

const monthlyEnergyRef = ref(null)
const monthlyEnergy = ref([])

const monthlyBodyWeightRef = ref(null)
const monthlyBodyWeight = ref([])

const monthlyCaloriesExpendedRef = ref(null)
const monthlyCaloriesExpended = ref([])

const trainingItemRefs = ref([])

function assignRef(el, index) {
  console.log('assignRef', el)
  trainingItemRefs.value[index] = el
  console.log('trainingItemRefs.value', trainingItemRefs.value)
}

const trainingSetCategories = ref([
  'Set 1', 'Set 2', 'Set 3', 'Set 4', 'Set 5', 'Set 6',
])

const trainingSetXAxis = ref({
  tickAmount: 6,
})

const trainingSetYAxis = ref({
  // tickAmount: 3,
})

// ref({
//   max: 3,
//   tickAmount: 3,
//   labels: {
//     formatter: val => labelFormatter(workoutType.value, val),
//   },
// })
function refresh() {
  if (weeklyWordoutTypeRef.value) {
    weeklyWordoutTypeRef.value.refresh()
  }
  if (weeklyWorkoutIntensityRef.value) {
    weeklyWorkoutIntensityRef.value.refresh()
  }
  if (weeklySleepRef.value) {
    weeklySleepRef.value.refresh()
  }
  if (weeklyAppetiteRef.value) {
    weeklyAppetiteRef.value.refresh()
  }
  if (weeklyMoodRef.value) {
    weeklyMoodRef.value.refresh()
  }
  if (weeklyEnergyRef.value) {
    weeklyEnergyRef.value.refresh()
  }
  if (weeklyBodyWeightRef.value) {
    weeklyBodyWeightRef.value.refresh()
  }
  if (weeklyCaloriesExpendedRef.value) {
    weeklyCaloriesExpendedRef.value.refresh()
  }

  if (monthlyWordoutTypeRef.value) {
    monthlyWordoutTypeRef.value.refresh()
  }
  if (monthlyWorkoutIntensityRef.value) {
    monthlyWorkoutIntensityRef.value.refresh()
  }
  if (monthlySleepRef.value) {
    monthlySleepRef.value.refresh()
  }
  if (monthlyAppetiteRef.value) {
    monthlyAppetiteRef.value.refresh()
  }
  if (monthlyMoodRef.value) {
    monthlyMoodRef.value.refresh()
  }
  if (monthlyEnergyRef.value) {
    monthlyEnergyRef.value.refresh()
  }
  if (monthlyBodyWeightRef.value) {
    monthlyBodyWeightRef.value.refresh()
  }
  if (monthlyCaloriesExpendedRef.value) {
    monthlyCaloriesExpendedRef.value.refresh()
  }

  if (trainingItemRefs.value.length > 0) {
    for (let index = 0; index < trainingItemRefs.value.length; index += 1) {
      const trainingItemRef = trainingItemRefs.value[index]
      console.log('trainingItemRef', trainingItemRef)
      trainingItemRef.refresh()
    }
  }
}

// workoutType load local data
const workoutType = ref(fetchWorkoutType())

const courseComment = ref(fetchCourseComment())

function labelFormatter(selection, val) {
  // console.log('workoutTypeLabelFormatter', selection, val)

  const typeItem = selection.find(item => item.value === val)

  if (typeItem) {
    return typeItem.description
  }

  return ''
}
function workoutTypeFormmater(val) {
  return labelFormatter(workoutType.value, val)
}

function weeklyXAxisFormmater(day, m, y) {
  // console.log('xAxis', day, m, y)

  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  return days[day - 1]
}

function getRandomColor(index) {
  const colors = [
    '#2D78F0',
    '#DA0063',
    '#2D78F0',
    '#96D45A',
    '#DA0063',
    '#F24726',
    '#FF6347',
    '#48D1CC',
  ]

  return colors[index]
}

const weeklyXAxis = ref({
  tickAmount: 7,
  labels: {
    formatter: (day, m, y) => weeklyXAxisFormmater(day, m, y),
  },
})

const monthlyXAxis = ref({
  tickAmount: 10,
})

const courseCommentYAxis = ref({
  max: 4,
  tickAmount: 4,
  labels: {
    formatter: val => labelFormatter(courseComment.value, val),
  },
})

const workoutTypeYAxis = ref({
  max: 3,
  tickAmount: 3,
  labels: {
    formatter: val => labelFormatter(workoutType.value, val),
  },
})

const tab = ref(0)
const title = ref('Diary Chart')

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  record: {
    type: Object,
    default() {
      return {
        userRecordID: 0,
        courseDate: '0001-01-01T00:00:00.000Z',
        courseDay: 0,
        workoutTypeID: 0,
        workoutIntensity: 0,
        dailyEvaluation: '',
        hourSelptLastNight: 0,
        moodID: 2,
        appetiteID: 0,
        energyID: 0,
        bodyWeight: 0,
        caloriesExpended: 0,
        trainingItems: [
        ],
        trainingAerobicItems: [],
        id: 0,
      }
    },
  },
})
const { value, record } = toRefs(props)

const dialog = ref(value.value)

const emits = defineEmits(['input', 'closed'])
watch(dialog, val => {
  console.log('diaryDialog', val)
  emits('input', val)
})

watch(value, val => {
  console.log('value', val)
  dialog.value = val
})

function getStartOfNextMonth(dateString) {
  const date = moment(dateString)
  const firstDayOfNextMonth = date.add(1, 'months').startOf('month')

  return firstDayOfNextMonth.format('YYYY-MM-DD')
}

function getCategoriesByType(dateString, type) {
  const date = moment(dateString)
  const startOfWeek = date.clone().startOf(type)
  const endOfWeek = date.clone().endOf(type)

  const weekDates = []
  for (let day = startOfWeek; day.isBefore(endOfWeek) || day.isSame(endOfWeek); day.add(1, 'day')) {
    weekDates.push(day.clone())
  }

  return weekDates
}

function getValueByID(array, id) {
  return array.find(item => item.id === id).value
}

function clearData() {
  // clear week
  weeklyCategories.value = []

  weeklyWorkoutType.value = []
  weeklyWorkoutIntensity.value = []
  weeklyAppetite.value = []
  weeklyMood.value = []
  weeklyEnergy.value = []
  weeklyBodyWeight.value = []
  weeklyCaloriesExpended.value = []

  // clear month
  monthlyCategories.value = []

  monthlyWorkoutType.value = []
  monthlyWorkoutIntensity.value = []
  monthlyAppetite.value = []
  monthlyMood.value = []
  monthlyEnergy.value = []
  monthlyBodyWeight.value = []
  monthlyCaloriesExpended.value = []

  trainingItemRefs.value = []
}

const items = ref([])
watch(dialog, val => {
  // console.log('record value', val)
  if (val) {
    if (record.value.userRecordID > 0) {
      // console.log('record.value', record.value)

      loading(true)
 
      // get record from backend
      listForChart({
        userRecordID: record.value.userRecordID,

        // from 1st of target month
        startDate: getStartOfMonth(record.value.courseDate),

        // to 1st of next month
        endDate: getStartOfNextMonth(record.value.courseDate),
      }).then(res => {
        console.log('listForChart res', res)
        items.value = [...res.data.items]

        // get weekDates from sat to sun, e.g.04-30,05-01...05-06
        const weekDates = getCategoriesByType(record.value.courseDate, 'week')
        console.log('weeklyCategories.value', weeklyCategories.value)

        const monthDates = getCategoriesByType(record.value.courseDate, 'month')

        // clear previous data
        clearData()

        // loop week dates
        for (let index = 0; index < weekDates.length; index += 1) {
          const date1 = weekDates[index]
          weeklyWorkoutType.value[index] = 0
          weeklyWorkoutIntensity.value[index] = 0
          weeklySleep.value[index] = 0
          weeklyAppetite.value[index] = 0
          weeklyMood.value[index] = 0
          weeklyEnergy.value[index] = 0
          weeklyBodyWeight.value[index] = 0
          weeklyCaloriesExpended.value[index] = 0

          // assign weekly data
          const date1String = date1.format('YYYY-MM-DD')
          items.value.forEach(item => {
            // console.log("date1.format('YYYY-MM-DD') === formatDate(item.courseDate)", date1String, formatDate(item.courseDate))
            if (date1String === formatDate(item.courseDate)) {
              weeklyWorkoutType.value[index] = getValueByID(workoutType.value, item.workoutTypeID)
              weeklyWorkoutIntensity.value[index] = item.workoutIntensity
              weeklySleep.value[index] = item.hourSelptLastNight

              weeklyAppetite.value[index] = getValueByID(courseComment.value, item.appetiteID)
              weeklyMood.value[index] = getValueByID(courseComment.value, item.moodID)
              weeklyEnergy.value[index] = getValueByID(courseComment.value, item.energyID)

              weeklyBodyWeight.value[index] = item.bodyWeight
              weeklyCaloriesExpended.value[index] = item.caloriesExpended
            }
          })

          // assign weeklyCategories data
          weeklyCategories.value.push(weekDates[index].format('MM-DD'))
        }

        // loop month dates
        for (let index = 0; index < monthDates.length; index += 1) {
          const date1 = monthDates[index]
          monthlyWorkoutType.value[index] = 0
          monthlyWorkoutIntensity.value[index] = 0
          monthlySleep.value[index] = 0
          monthlyAppetite.value[index] = 0
          monthlyMood.value[index] = 0
          monthlyEnergy.value[index] = 0
          monthlyBodyWeight.value[index] = 0
          monthlyCaloriesExpended.value[index] = 0

          // assign weekly data
          const date1String = date1.format('YYYY-MM-DD')
          items.value.forEach(item => {
            // console.log("date1.format('YYYY-MM-DD') === formatDate(item.courseDate)", date1String, formatDate(item.courseDate))
            if (date1String === formatDate(item.courseDate)) {
              monthlyWorkoutType.value[index] = getValueByID(workoutType.value, item.workoutTypeID)
              monthlyWorkoutIntensity.value[index] = item.workoutIntensity
              monthlySleep.value[index] = item.hourSelptLastNight

              monthlyAppetite.value[index] = getValueByID(courseComment.value, item.appetiteID)
              monthlyMood.value[index] = getValueByID(courseComment.value, item.moodID)
              monthlyEnergy.value[index] = getValueByID(courseComment.value, item.energyID)

              monthlyBodyWeight.value[index] = item.bodyWeight
              monthlyCaloriesExpended.value[index] = item.caloriesExpended
            }
          })

          // assign weeklyCategories data
          monthlyCategories.value.push(monthDates[index].format('MM-DD'))
        }

        // refresh chart
        refresh()
      }).finally(() => {
        loading(false)
      })
    }
  } else {
    tab.value = 0
  }
})

const nodeHeight = ref('0px')
function updateNodeHeight() { nodeHeight.value = `${window.innerHeight - 105}px` }

function getCourseItemDesc(courseItemID) {
  const courseItem = getCourseItem(courseItemID)
  if (courseItem) {
    return courseItem.description
  }

  return ''
}

function getCourseItem(courseItemID) {
  // console.log('courseItemID', courseItemID)
  if (courseItems.value.length > 0) {
    const courseItem = courseItems.value.find(item => item.id === courseItemID)
    if (courseItem && trainingSetUnits.value.length > 0) {
      return courseItem  
    }
  }

  return null
}

function getUnit(courseItemID) {
  // console.log('getUnit', courseItemID)
  const courseItem = getCourseItem(courseItemID)
  if (courseItem && trainingSetUnits.value.length > 0) {
    const setUnit = trainingSetUnits.value.find(trainingSetUnit => trainingSetUnit.id === courseItem.trainingSetUnitID)
    if (setUnit) {
      return setUnit.description
    }
  }

  return 'Times'
}

function getSeries(trainingItem) {
  // console.log('trainingItem', trainingItem)
  const name2 = getUnit(trainingItem.courseItemID)
  let data1 = []
  if (trainingItem.trainingSets.length > 0) {
    data1 = trainingItem.trainingSets.map(set => set.lbsKgs)
  }

  let data2 = []
  if (trainingItem.trainingSets.length > 0) {
    data2 = trainingItem.trainingSets.map(set => set.qty)
  }

  return [{
    name: 'lbs/Kgs',
    data: data1,
  },
  {
    name: name2,
    data: data2,
  }]
}

function goTo(target) {
  // wait page loaded then scoll the page to target
  setTimeout(() => {
    if (target === 'bodyWeight') {
      $vuetify.goTo(weeklyBodyWeightRef.value, { container: tabsItemsRef.value })
    } else if (target === 'dailyEvaluation') {
      $vuetify.goTo(weeklySleepRef.value, { container: tabsItemsRef.value })
    } else if (target === 'caloriesExpended') {
      $vuetify.goTo(weeklyCaloriesExpendedRef.value, { container: tabsItemsRef.value })
    } else if (target === 'trainingItem') {
      tab.value = 2
      $vuetify.goTo(trainingItemsRef.value, { container: tabsItemsRef.value })
    }
  }, 500)
}

onMounted(() => {
  dialog.value = value.value
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

defineExpose({ tab, goTo })

</script>
<style scoped>
.chart-tabs{
  overflow-y: scroll;
}
.color-1{ color: #5D737E; /* Slate Blue */ }
.color-2{ color: #64B6AC; /* Light Teal */ }
.color-3{ color: #D0E2B4; /* Soft Green */ }
.color-4{ color: #E898AC; /* Rose Pink */ }
.color-5{ color: #E89B88; /* Coral */ }
.color-6{ color: #DBB1B1; /* Soft Red */ }
.color-7{ color: #A9C5A0; /* Soft Green */ }
</style>
